import React from "react";
import Edit03 from "../../../Svg/Edit03";
import Tooltip from "../../CommonComponents/Tooltip";
import { isEnableProfileDetailsEdit } from "../../../util";

const Work = ({ id, details, handleEditWork, handleDelete, from }) => {
  return (
    <React.Fragment>
      {details?.map((detail, index) => (
        <div className="workContainer" key={index}>
          <div className="workTitle">{detail.title?.substring(0, 50)}</div>
          <div className="workBtnSec">
            {isEnableProfileDetailsEdit && (
              <Tooltip title="Delete" placement={"bottom"} theme="dark" isIcon={true}>
                <div
                  className="workDeleteBtn"
                  onClick={() => handleDelete(id, detail)}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 4.99999H4.16667M4.16667 4.99999H17.5M4.16667 4.99999V16.6667C4.16667 17.1087 4.34226 17.5326 4.65482 17.8452C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8452C15.6577 17.5326 15.8333 17.1087 15.8333 16.6667V4.99999H4.16667ZM6.66667 4.99999V3.33332C6.66667 2.8913 6.84226 2.46737 7.15482 2.15481C7.46738 1.84225 7.89131 1.66666 8.33333 1.66666H11.6667C12.1087 1.66666 12.5326 1.84225 12.8452 2.15481C13.1577 2.46737 13.3333 2.8913 13.3333 3.33332V4.99999M8.33333 9.16666V14.1667M11.6667 9.16666V14.1667"
                      stroke="#344054"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Tooltip>
            )}
            <Tooltip title="Edit" placement={"bottom"} theme="dark" isIcon={true}>
              <div className="workEditBtn">
                <Edit03
                  stroke="#344054"
                  width="20"
                  height="20"
                  strokeWidth="1.2"
                  onClick={() => handleEditWork(id, detail)}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      ))}
    </React.Fragment>
  );
};

export default Work;
